The date & time the event was added to the stream.

Initial `afterDateTime` and `beforeDateTime` filters apply to this field.
